import { z } from 'zod'

import { IntegrationSchema } from 'shared/api/common/schemas/integration'

const ConvertKitFormSchema = z.object({
  id: z.number(),
  name: z.string(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  created_at: z.string(),
})

const ConvertKitItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  created_at: z.string(),
})

export const ConvertKitSchemas = {
  setAccountLinkField: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ field_id: z.string().nullable(), field_name: z.string().nullable() }),
    response: z.object({ integration: IntegrationSchema }),
  },
  clearAccountLinkField: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({ integration: IntegrationSchema }),
  },
  getForms: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({ forms: z.array(ConvertKitFormSchema).or(z.array(z.void()).length(0)) }),
  },
  getSequences: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({
      sequences: z.array(ConvertKitItemSchema).or(z.array(z.void()).length(0)),
    }),
  },
  getTags: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({ tags: z.array(ConvertKitItemSchema).or(z.array(z.void()).length(0)) }),
  },
  getFields: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({
      fields: z
        .array(z.object({ key: z.string(), label: z.string() }))
        .or(z.array(z.void()).length(0)),
    }),
  },
}
